import styled from "@emotion/styled";
import { CircularProgress, IconButton } from "@mui/material";
import { StyleScrollableContainer } from "scmp-sdk/components/dashboard-widget/display/styles";

import { fontRoboto, fontRobotoCondensed, theme, transientOptions } from "shared/lib/styles";

import ReadingHistoryEmptyIcon from "./icon-reading-history-empty.svg";

export const Container = styled.div`
  block-size: 100%;
  padding: 20px;

  background: #ffffff;

  overflow-y: auto;
  ${StyleScrollableContainer}
`;

export const Title = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 19px;
`;

export const Section = styled.div``;

export const SectionHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  padding-block: 20px;
`;

export const HeaderTitle = styled.div`
  color: #000000;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 18px;
  text-transform: uppercase;
`;

export const PlainTextButton = styled.button`
  color: #4585ff;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;

  border: none;

  background: transparent;

  cursor: pointer;
`;

export const SectionItem = styled.div`
  position: relative;

  padding-block-end: 28px;
  padding-inline-start: 20px;

  ::before {
    position: absolute;
    inset-block-start: 2px;
    inset-inline-start: 0;
    content: "";
    z-index: 2;

    display: block;

    inline-size: 10px;
    block-size: 10px;

    border-radius: 50%;

    background: #ffca05;
  }

  ::after {
    position: absolute;
    inset-block-start: 2px;
    inset-inline-start: 0;
    content: "";
    z-index: 1;

    display: block;

    inline-size: 10px;
    block-size: calc(100% + 8px);

    border-radius: 5px 5px 0 0;

    background: #f2f2f2;
  }

  :last-child {
    ::after {
      block-size: calc(100% - 2px);
    }
  }
`;

export const ItemTitle = styled.div`
  color: #666666;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 22px;

  cursor: pointer;
  ${theme.breakpoints.up("tablet")} {
    font-size: 14px;
    line-height: 18px;
  }

  :hover {
    color: #4585ff;
  }
`;

type ItemButtonProps = { $isActive: boolean };

export const ItemButton = styled(IconButton, { ...transientOptions })<ItemButtonProps>`
  padding-block: 4px;
  padding-inline: 0;

  color: ${props => (props.$isActive ? "#000000" : "#cccccc")};
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  margin-block-start: 16px;

  color: #666666;
  font-size: 14px;
  font-family: ${fontRoboto};
`;

export const StyledReadingHistoryEmptyIcon = styled(ReadingHistoryEmptyIcon)`
  min-inline-size: 180px;
  max-inline-size: 250px;
  margin-block-start: 28px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 180px;
  }
`;

export const Loading = styled(CircularProgress)`
  display: block;

  margin-block: 30px;
  margin-inline: auto;

  color: #4585ff;
`;
